<template>
  <!-- Colonne avec le nom de la ressource -->
  <div class="flex justify-end border border-gray-800 rounded-l-lg font-bold h-[60px] select-none"
    :style="{
      backgroundColor: row.color,
      color: getTextColor(row.color),
    }"
  >
    <div class="m-2 flex items-center">{{ row.name }}</div>
  </div>
  <!-- Pour chaque jour -->
  <template v-for="(day, dIndex) in dateArrays.days" :key="'day-' + dIndex">
    <!-- Pour chaque créneau -->
    <template v-for="(slot, sIndex) in slotsForADay" :key="'day-' + dIndex + 'slot-' + slot.startMinute">
      <div 
        :style="{backgroundColor: getSlotBackgroundColor(day, slot.active),}"
        :class="[
          (state.selectedView.name == 'Année') ? '' : 'border-r border-r-[#bbbbbb]',
          (sIndex === slotsForADay.length - 1) ? 'border-r-gray-700' : '',
          (isDayOff(day) && state.selectedView.name != 'Année') ? 'border-r border-r-gray-600' : 'border-r border-r-[#bbbbbb]',
        ]"
        class="p-0 hover:!bg-red-200 cursor-pointer w-full min-w-0 col-span-1 border-b border-b-gray-600"
        :data-slotMinute="slot.startMinute"
        :data-endMinute="slot.endMinute"
        :data-day="dayToKey(day)"
        :data-rowid="row.id"
        @mousedown="startSlotSelection($event)"
      >
        <template v-if="sIndex == 0">
          <!-- Pour chaque événement -->
          <div v-for="event in eventsForDay(day)" :key="event.id">
            <div v-if="event.width > 0 && (state.project || event.showInGlobalPlanning)"
              :style="{backgroundColor: event.color, color: getTextColor(event.color), width: event.width * minuteWidth + 'px', left: event.left ? event.left * minuteWidth + 216 + minuteWidth * daysMinuteWidth * dIndex + 'px' : 'auto'}"
              class="border-t border-b cursor-pointer absolute h-[50px] select-none z-0"
              :class="[
                (event.firstDay ? 'border-l':''),
                (event.lastDay ? 'border-r':''),
                (draggingEventData && draggingEventData.id == event.id) ? 'dragging-shadow' : '',
              ]"
              :title="event.title"
              @mousedown="startDrag($event, event)"
              @click.stop
              @mousedown.stop
              @dblclick="$emit('open-event-popup', event)"
            >
              <div v-if="event.firstDay && event.width * minuteWidth > 25" class="h-full relative m-1 ml-2 text-left select-none overflow-hidden w-full" :style="{width: event.width * minuteWidth - 12 + 'px'}">
                <span class="h-fit w-full text-left absolute truncate z-999">{{ event.noEdit ? "Déplacement" : event.title }}</span>
              </div>
              <div v-if="isEventFinished(event)" class="absolute bottom-0 left-0 w-full h-1/10 bg-green-500">
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>

    <div 
      v-if="selectRect" 
      class="fixed bg-red-200 pointer-events-none"
      :style="{
        top: selectRect.top + 'px',
        left: selectRect.left + 'px',
        width: selectRect.width + 'px',
        height: selectRect.height + 'px'
      }"
    >
      
    </div>
   
  </template>
</template>

<script>
import { fetchRessources } from '@/services/ressourceService';
import { updateEvent } from '@/services/eventService';

import { inject } from 'vue';

export default {
  props: {
    row: Object,
    slotsForADay: Array,
    eventsByDay: Object,
    minuteWidth: Number,
    slotInterval: Number,
  },
  setup(){
    const state = inject('state');
    const dateArrays = inject('dateArrays');
    const events = inject('events');
    const parameters = inject('parameters');
    const perm = inject('userPerm');
    return { state, dateArrays, events, parameters, perm };
  },
  emits: ['open-event-popup'],
  data() {
    return {
      draggingElement: null,
      dragOffset: 0, // Différence entre la position du clic et le bord gauche de l'élement
      dragDayIndex: null,
      draggingEventData: null, // Stocke l'objet global de l'événement glissé
      draggingEventRowIndex: "",
      boundOnDrag: null,
      boundStopDrag: null,
      startDraggingSlot: null,

      selectRect: null,
      emptyEvent: {
        ressources: this.project ? this.project.ressources : [],
        startDate: new Date(),
        endDate: new Date(),
        accessTime: "00:00",
        showInGlobalPlanning: true,
        projectSection: "",
        title: "",
        description: "",
        projectId: this.state.project ? this.state.project.id : "",
        clientId: "",
        isFinished: false,
        color: "#E8535D",
        tasks: [],
        reminders: [],
      }
    };
  },
  created() {
    // Stocker la référence liée pour s'assurer qu'elle reste la même
    this.boundOnDrag = this.onDrag.bind(this);
    this.boundStopDrag = this.stopDrag.bind(this);
  },
  computed:{
    daysMinuteWidth(){
      return this.parameters.night ? 1440 : this.parameters.endMinute - this.parameters.startMinute;
    }
  },
  methods: {
    isEventFinished(event) {
      if (!event.tasks || !Array.isArray(event.tasks) || event.tasks.length === 0) return false;
      return event.tasks.every(task => task.isFinished === true);
    },
    isDayOff(day) {
      const dayOff = this.parameters.daysOff.includes(new Date(day).getDay());
      return dayOff;
    },
    isOddMonth(day) {
      const month = new Date(day).getMonth() + 1; // Les mois commencent à 0
      return month % 2 !== 0;
    },
    getSlotBackgroundColor(day, active) {
      // if(this.state.project){
      //   if(new Date(day) < new Date(this.state.project.startDate).setDate(new Date(this.state.project.startDate).getDate() - 1) || new Date(day) > new Date(this.state.project.endDate)){
      //     return '#FF2222';
      //   }
      // }

      if(new Date(day) >= new Date().setDate(new Date().getDate() - 1)){
        if (this.isDayOff(day)) return '#6B7280';
        if(!active) return '#9CA3AF';
        if(this.isOddMonth(day)) return '#F3F4F6';
        return '#D1D5DB'; // Couleur de fond par défaut
      }
      else{
        if (this.isDayOff(day)) return '#4B5563';
        if(!active) return '#6B7280';
        return '#9CA3AF'; // Couleur de fond par défaut
      }
    },
    getTextColor(hex) {
      // Supprime le '#' si présent
      if (hex.startsWith('#')) {
        hex = hex.slice(1);
      }
      // Gérer le format raccourci (ex. 'abc' -> 'aabbcc')
      if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      // Calcul de la luminosité (formule standard)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      // Si la couleur est foncée, on retourne du blanc, sinon du noir
      return brightness < 128 ? '#fff' : '#000';
    },
    eventsForDay(day) {  
      let dayEvents = this.eventsByDay[this.dayToKey(day)] || [];
      let filteredEvents = [];
      switch(this.state.selectedRows.name){
        case "Ressources":
          filteredEvents = dayEvents.filter(event =>
            event.ressources.some(ressource => 
              String(ressource.ressourceId) === String(this.row.id)
            )
          );
          filteredEvents = dayEvents.filter(event => event.ressources.some(ressource => ressource.ressourceId == this.row.id));
          break;
        case "Equipes":
          for(let ressource of this.state.rows[0].rows){
            for(let e of dayEvents){
              if(e.ressources.some(ressourceEvent => ressourceEvent.ressourceId == ressource.id)){
                if(ressource.team == this.row.id){
                  filteredEvents.push(e);
                }
              }
            }
          }
          break;
        case "Clients":
          filteredEvents = dayEvents.filter(event => event.clientId == this.row.id);
          break;
        case "Projet en cours":
          filteredEvents = dayEvents.filter(event => event.projectId == this.row.id);
          break;
        case "Actions":
          filteredEvents = dayEvents.filter(event => event.title == this.row.id);
          break;
        default:
          return dayEvents.filter(event => 
            event.ressources.some(ressource => ressource.ressourceId === this.row.id)
          );
      }

      // Vérifie si filteredEvents contient un événement avec un id spécifique (par exemple, id = 123)
      // Remplacez 123 par l'id que vous souhaitez vérifier
      const specificId = "67pv7ZjHe96R5MIWYBnK";
      const hasSpecificEvent = filteredEvents.some(event => event.id === specificId);

      if(hasSpecificEvent)
        console.log(`Found specific event with id ${specificId}`, filteredEvents.find(event => event.id === specificId));
      // Vous pouvez utiliser hasSpecificEvent selon vos besoins (console.log, return, etc.)

      return filteredEvents;
    },
    dayToKey(day){
      return day.getFullYear() + '-' +
        (day.getMonth() + 1).toString().padStart(2, '0') + '-' +
        day.getDate().toString().padStart(2, '0');
    },
    calculateNewDate(day, minuteOffset) {
      if (this.state.selectedView.name === 'Mois' || this.state.selectedView.name === 'Année') {
        const origDate = new Date(this.draggingEventData.startDate);
        const hourMinuteStr =
          origDate.getHours().toString().padStart(2, '0') + ':' +
          origDate.getMinutes().toString().padStart(2, '0');
        return new Date(`${day}T${hourMinuteStr}:00`);
      }
      else {
        // Sinon, utiliser le calcul habituel basé sur le minuteOffset
        const hours = Math.floor(minuteOffset / 60);
        const minutes = minuteOffset % 60;
        const hourMinuteStr = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        return new Date(`${day}T${hourMinuteStr}:00`);
      }
    },
    getSlotElementFromMouseEvent(mouseEvent) {
      const elements = document.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
      return elements.find(el => el.dataset.slotminute);
    },
    calculateMouseMinutes(clientX) {
      let mouseMinutes = Math.round((clientX - 216) / this.minuteWidth) % this.daysMinuteWidth;

      if(!this.parameters.night){
        mouseMinutes += this.parameters.startMinute;
      }

      console.log(mouseMinutes);
      return mouseMinutes;
    },
    calculateDragOffset(startDate, mouseDate) {
      return Math.round((mouseDate.getTime() - startDate.getTime()) / (1000 * 60));
    },
    addDragEventListeners() {
      document.addEventListener('mousemove', this.boundOnDrag);
      document.addEventListener('mouseup', this.boundStopDrag);
    },
    calculateNewStartDate(slotElement) {
      let realEventMinute = Math.round((slotElement.dataset.slotminute - this.dragOffset) / this.slotInterval) * this.slotInterval;

      const dayNumDiff = Math.ceil(Math.abs(realEventMinute) / 1440);
      
      if (realEventMinute < 0) {
        realEventMinute += 1440 * dayNumDiff;
        const previousDay = new Date(slotElement.dataset.day);
        previousDay.setDate(previousDay.getDate() - dayNumDiff);
        const previousDayKey = this.dayToKey(previousDay);
        return this.calculateNewDate(previousDayKey, realEventMinute);
      }

      return this.calculateNewDate(slotElement.dataset.day, realEventMinute);
    },
    calculateNewEndDate(newStartDate) {
      const eventDuration = new Date(this.draggingEventData.endDate) - new Date(this.draggingEventData.startDate);
      return new Date(newStartDate.getTime() + eventDuration);
    },
    async emitUpdatedEvent(newStartDate, newEndDate, rowId) {
      let newRessources = this.draggingEventData.ressources;

      if(this.state.selectedRows.name == "Ressources")
        newRessources[this.draggingEventRowIndex].ressourceId = rowId;

      const foundEvent = this.events.find(e => e.id === this.draggingEventData.id);
      if (!foundEvent) return;
      // Mettre à jour l'événement global
      foundEvent.startDate = new Date(newStartDate).toString();
      foundEvent.endDate = new Date(newEndDate).toString();
      foundEvent.ressources = newRessources;
      
      if (foundEvent.accessId) {
        // Récupère les nouvelles dates calculées par updateEvent
        const accessEvent = this.events.find(e => e.id === foundEvent.accessId);
        if (accessEvent) {
          // Re-fetch depuis Firestore pour avoir les vraies dates, ou recalculer localement
          const accessTime = foundEvent.accessTime || "00:00";
          const [hours, minutes] = accessTime.split(':').map(Number);
          const accessTimeInMs = (hours * 60 + minutes) * 60 * 1000;
          const startDate = new Date(foundEvent.startDate);
          const endDate = new Date(foundEvent.endDate);

          accessEvent.startDate = new Date(startDate.getTime() - accessTimeInMs - 1).toString();
          accessEvent.endDate = new Date(endDate.getTime() + accessTimeInMs).toString();
          accessEvent.ressources = newRessources;
          await updateEvent(accessEvent);
        }
      }
      await updateEvent(foundEvent);
    },
    async startSlotSelection(mouseEvent) {
      mouseEvent.preventDefault();

      const slotElement = this.getSlotElementFromMouseEvent(mouseEvent);
      if (!slotElement) return;

      this.startDraggingSlot = slotElement;

      if(this.startDraggingSlot) {
        let startSlot = this.startDraggingSlot;
        let endSlot = slotElement;

        let startSlotDate = new Date(`${this.startDraggingSlot.dataset.day}T00:00:00`);
        startSlotDate.setMinutes(parseInt(this.startDraggingSlot.dataset.slotminute));
        
        let endSlotDate = new Date(`${slotElement.dataset.day}T00:00:00`);
        endSlotDate.setMinutes(parseInt(slotElement.dataset.slotminute));

        if (endSlotDate < startSlotDate) {
          [startSlot, endSlot] = [endSlot, startSlot];
          [startSlotDate, endSlotDate] = [endSlotDate, startSlotDate];
        }

        endSlotDate = new Date(`${endSlot.dataset.day}T00:00:00`);
        endSlotDate.setMinutes(parseInt(endSlot.dataset.endminute));

        this.emptyEvent.startDate = new Date(startSlotDate);
        this.emptyEvent.endDate = new Date(endSlotDate);

        if(this.state.selectedRows.name == "Ressources"){
          this.emptyEvent.ressources = [{id: 0, ressourceId: startSlot.dataset.rowid}];
        }
        else if (this.state.selectedRows.name == "Equipes") {
          let ressources = await fetchRessources();
          let teamRessources = ressources.filter(r => r.team == this.row.id).map(r => ({id: 0, ressourceId: r.id}));
          this.emptyEvent.ressources = teamRessources;
        }
        else if (this.state.selectedRows.name == "Clients") {
          this.emptyEvent.clientId = this.row.id;
        }

        if(this.state.project){
          this.emptyEvent.projectId = this.state.project.id;
        }
        
        if(!this.startDraggingSlot) return;
        this.selectRect = {
          top: this.startDraggingSlot.getBoundingClientRect().top,
          left: startSlot.getBoundingClientRect().left,
          width: endSlot.getBoundingClientRect().right - startSlot.getBoundingClientRect().left,
          height: this.startDraggingSlot.getBoundingClientRect().height
        };
      }

      this.addDragEventListeners();
    },
    startDrag(mouseEvent, eventData) {
      if(eventData.noEdit) return; // Ne pas permettre le drag si l'événement est en lecture seule

      mouseEvent.preventDefault();
      this.draggingEventData = eventData;

      const slotElement = this.getSlotElementFromMouseEvent(mouseEvent);
      if (!slotElement) return;

      const startDate = new Date(this.draggingEventData.startDate);
      const mouseMinutes = this.calculateMouseMinutes(mouseEvent.clientX);
      const mouseDate = this.calculateNewDate(slotElement.dataset.day, mouseMinutes);
      this.dragOffset = this.calculateDragOffset(startDate, mouseDate);

      this.draggingEventRowIndex = this.draggingEventData.ressources.findIndex(r => r.ressourceId == slotElement.dataset.rowid);
      
      // Ajouter un écouteur global pour détecter un relâchement de la souris avant le délai
      const cancelDrag = () => {
        if (this.dragTimeout) {
          clearTimeout(this.dragTimeout);
          this.dragTimeout = null;
          this.draggingEventData = null;
        }
        document.removeEventListener('mouseup', cancelDrag); // Nettoyer l'écouteur
      };
      document.addEventListener('mouseup', cancelDrag);

      // Ajouter un délai avant de commencer le drag
      this.dragTimeout = setTimeout(() => {
        document.removeEventListener('mouseup', cancelDrag); // Nettoyer l'écouteur après le délai
        this.addDragEventListeners();
      }, 200); // Délai de 200ms avant de commencer le drag
    },
    async onDrag(mouseEvent) {
      const slotElement = this.getSlotElementFromMouseEvent(mouseEvent);
      if (!slotElement) return;

      if(this.startDraggingSlot) {
        let startSlot = this.startDraggingSlot;
        let endSlot = slotElement;

        let startSlotDate = new Date(`${this.startDraggingSlot.dataset.day}T00:00:00`);
        startSlotDate.setMinutes(parseInt(this.startDraggingSlot.dataset.slotminute));
        
        let endSlotDate = new Date(`${slotElement.dataset.day}T00:00:00`);
        endSlotDate.setMinutes(parseInt(slotElement.dataset.slotminute));

        if (endSlotDate < startSlotDate) {
          [startSlot, endSlot] = [endSlot, startSlot];
          [startSlotDate, endSlotDate] = [endSlotDate, startSlotDate];
        }

        endSlotDate = new Date(`${endSlot.dataset.day}T00:00:00`);
        endSlotDate.setMinutes(parseInt(endSlot.dataset.endminute));

        this.emptyEvent.startDate = new Date(startSlotDate);
        this.emptyEvent.endDate = new Date(endSlotDate);

        if(this.state.selectedRows.name == "Ressources"){
          this.emptyEvent.ressources = [{id: 0, ressourceId: startSlot.dataset.rowid}];
        }
        else if (this.state.selectedRows.name == "Equipes") {
          let ressources = await fetchRessources();
          let teamRessources = ressources.filter(r => r.team == this.row.id).map(r => ({id: 0, ressourceId: r.id}));
          this.emptyEvent.ressources = teamRessources;
        }
        else if (this.state.selectedRows.name == "Clients") {
          this.emptyEvent.clientId = this.row.id;
        }

        if(this.state.project){
          this.emptyEvent.projectId = this.state.project.id;
        }
        
        if(!this.startDraggingSlot) return;
        this.selectRect = {
          top: this.startDraggingSlot.getBoundingClientRect().top,
          left: startSlot.getBoundingClientRect().left,
          width: endSlot.getBoundingClientRect().right - startSlot.getBoundingClientRect().left,
          height: this.startDraggingSlot.getBoundingClientRect().height
        };
      }
      else{
        if (!this.draggingEventData) return;
        const newStartDate = this.calculateNewStartDate(slotElement, mouseEvent);
        const newEndDate = this.calculateNewEndDate(newStartDate);
        this.emitUpdatedEvent(newStartDate, newEndDate, slotElement.dataset.rowid);
      }
    },
    async stopDrag() {
      // Si un délai est en cours, l'annuler
      if (this.dragTimeout) {
        clearTimeout(this.dragTimeout);
        this.dragTimeout = null;
      }

      if (this.startDraggingSlot) {
        if(this.perm().planning == "modification"){
          this.$emit('open-event-popup', this.emptyEvent);
        }
        
        this.startDraggingSlot = null;
        this.selectRect = null;
      }
      else if (this.draggingEventData) {
        const foundEvent = this.events.find(e => e.id === this.draggingEventData.id);
        if (!foundEvent) return;
        
        // Supprimer les doublons dans les ressources basés sur ressourceId
        if (foundEvent.ressources && Array.isArray(foundEvent.ressources)) {
          const uniqueRessources = [];
          const seenRessourceIds = new Set();

          foundEvent.ressources.forEach(ressource => {
            if (!seenRessourceIds.has(ressource.ressourceId)) {
              seenRessourceIds.add(ressource.ressourceId);
              uniqueRessources.push(ressource);
            }
          });

          foundEvent.ressources = uniqueRessources;
        }
        
        this.draggingEventData = null;
        await updateEvent(foundEvent);
      }

      // Retirer les écouteurs d'événements
      document.removeEventListener('mousemove', this.boundOnDrag);
      document.removeEventListener('mouseup', this.boundStopDrag);
      // Réinitialiser l'état de glissement
      this.draggingEventData = null;
    },
  },
};
</script>

<style scoped>
.dragging-shadow {
  z-index: 10; /* Assurez-vous que l'élément est au-dessus des autres */
  transform: scale(1.01); /* Optionnel : effet de mise en avant */
  transition: box-shadow 0.2s ease, transform 0.2s ease; /* Animation douce */
}
</style>